angular.module('gym.calendar').factory('EventTypes', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('event_types');
}]);
